<table class="table__wrapper">
	<thead>
		<tr class="header__wrapper">
			<th class="header__text pl-8">
				<button class="flex flex-row" (click)="toggleSort()">
					Id
					@if (sortDirection === 'desc') {
						<activar-icon name="arrow_down"> </activar-icon>
					} @else {
						<activar-icon name="arrow_up"> </activar-icon>
					}
				</button>
			</th>
			@if (showUser()) {
				<th class="header__text ">Asegurado</th>
			}
			<th class="header__text">Cobertura</th>
			<th class="header__text">Riesgo</th>
			@if (showProducer()) {
				<th class="header__text">Productor</th>
			}
			<th class="header__text">Vigencia</th>
			<th class="header__text text-center">Estado</th>
			<th class="header__text px-8"></th>
		</tr>
	</thead>

	<tbody>
		@for (row of rows(); track row.id; let i = $index) {
			<tr
				class="body__wrapper"
				[ngClass]="i % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
				<td class="id__cell text-gray-600">
					{{ row.internalNumber }}
				</td>
				@if (showUser()) {
					<td>
						<activar-user-badge
							[firstName]="row.client.user.firstName"
							[lastName]="row.client.user.lastName"
							[email]="row.client.user.email!"
							[companyName]="row.client.user.companyName" />
					</td>
				}

				<td>
					{{ row.coverageName }}
				</td>
				<td [title]="row.risk.description">
					<div class="ellipsis">
						<activar-icon-title
							[icon]="getIconName(row.risk.tag)"
							[title]="row.risk.description" />
					</div>
				</td>
				@if (showProducer()) {
					<td class="">
						@if (row.client.agent.user.companyName) {
							{{ row.client.agent.user.companyName }}
						} @else {
							{{ row.client.agent.user.firstName || '-' }}
							{{ row.client.agent.user.lastName || '' }}
						}
					</td>
				}
				<td class="text-nowrap">
					{{ row.startDate | date: 'dd/MM/yyyy' }} -
					{{ row.endDate | date: 'dd/MM/yyyy' }}
				</td>

				<td>
					<activar-badge
						class="flex justify-center"
						[text]="row.badgeText"
						[status]="row.badgeStatus" />
				</td>

				<td class="text-center">
					<a
						[routerLink]="['/polizas', row.id]"
						class="text-primary-600 font-semibold">
						Ver
					</a>
				</td>
			</tr>
		} @empty {
			<tr class="body__wrapper">
				<td class="my-5" colspan="7">
					<div
						class="flex flex-col items-center justify-center text-center w-full my-5">
						<div class="mb-8">
							No se encontraron pólizas para mostrar.
						</div>
						<img src="empty_list.svg" alt="empty" />
					</div>
				</td>
			</tr>
		}
	</tbody>
</table>
